import { render, staticRenderFns } from "./NgSelectOptions.vue?vue&type=template&id=7b744946"
import script from "./NgSelectOptions.vue?vue&type=script&lang=js"
export * from "./NgSelectOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports